import React, { useState } from 'react'
import { Dropdown, Avatar, DynamicIcon, Anchor, Button } from 'legion-ui'
import './style.scss'

const ExampleSix = () => {
  const [isOpen, setOpen] = useState(false)
  const toogle = () => setOpen(prev => !prev)
  const onClose = () => setOpen(false)

  return (
    <Dropdown 
      trigger={
        <Button iconRight={<DynamicIcon name="ChevronDown" />} variant="transparent" onClick={toogle}>
            <span className="example-menu">
                <Avatar size="medium" src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />
                <span className="example-menu-profile">
                    <span className="example-menu-name">Alwan Thio</span>
                    <span className="example-menu-role">Administrator</span>
                </span>
            </span>
        </Button>
      }
      onClose={onClose}
      isOpen={isOpen}
      borderRadius={8}
      position='center'
    >
      <div className="example-body">
          <Anchor iconLeft={<DynamicIcon name="User" />}>Profile</Anchor>
          <Anchor iconLeft={<DynamicIcon name="Settings" />}>Settings</Anchor>
          <Anchor iconLeft={<DynamicIcon name="Edit" />}>Edit Info</Anchor>
      </div>
      <div className="example-footer">
        <Anchor iconLeft={<DynamicIcon name="LogOut" />}>Sign Out</Anchor>
      </div>
    </Dropdown>
  )
}

export default ExampleSix